
export type PeriodicLabelsDict = {
    [key: string]: PeriodicLabels
}

export interface PeriodicLabels {
    wyst_w_przyrodzie: string,
    masa_atomowa: string,
    gestosc: string,
    temp_topnienia: string,
    temp_wrzenia: string,
    odkryty_przez: string,
    rok_odkrycia: string
    postac: string
}

export const PERIODIC_DEF_LABELS: PeriodicLabelsDict = {
    "pl": {
        gestosc: "Gęstość",
        masa_atomowa: "Masa atomowa",
        odkryty_przez: "Odkryty przez",
        rok_odkrycia: "Rok odkrycia",
        temp_topnienia: "Temperatura topnienia",
        temp_wrzenia: "Temperatura wrzenia",
        wyst_w_przyrodzie: "Występowanie w przyrodzie",
        postac: "Postać"
    },
    "en": {
        gestosc: "Density (when liquid at melting point)\n",
        masa_atomowa: "Atomic mass",
        odkryty_przez: "Discovered by",
        rok_odkrycia: "Year of discovery",
        temp_topnienia: "Melting",
        temp_wrzenia: "Boiling",
        wyst_w_przyrodzie: "Occurrence in nature",
        postac: "Standard state"
    }
}